import React, { useEffect, useState, useCallback } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { Modal } from 'react-bootstrap'
import labelKey from "../../localization/label.json"
import { useGetAllBankLineItemsOfCurrentUserQuery, useGetAllBankLineItemsQuery } from '../../../services/AutomationApi'
import { useSelector } from 'react-redux'
import DateComp from '../../../components/dateComponent/DateComp'
import CurrencyComp from '../../../components/currencyComponent/CurrencyComp'
import { constraintConfig } from '../../../constraintConfig'
import MergeLineItemConfirmationModal from './MergeLineItemConfirmationModal'
import Pagination from '../../../components/pagination/Pagination'
import { Alert } from 'react-bootstrap';
import ReactReadMoreReadLess from "react-read-more-read-less";


type Props = {
    show: boolean
    handleClose: () => void
    data?: any
    selectedDraftData: any,
    refetch?: any
    setShowInnerTable?: any
    onSuccess?: () => void
}
const modalsRoot = document.getElementById('root-modals') || document.body


const MergeExpenseModal = ({ show, handleClose, data, refetch, selectedDraftData, onSuccess }: Props) => {
    console.log('selectedDraftData', selectedDraftData)

    const userId = useSelector((state: any) => state?.auth?.userAccountID ?? null)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [pageNumber, setPageNumber] = useState(1)
    const [pageSize, setPageSize] = useState(20);

    const [searchStr, setSearchStr] = useState('');
    const [immediateSearchStr, setImmediateSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("ccItemImportDate");
    const [sortOrder, setSortOrder] = useState("desc");
    const [selectedBankItemId, setSelectedBankItemId] = useState<number | null>(null);
    const [selectedBankItemData, setSelectedBankItemData] = useState<any>(null);

    const handleConfirmMerge = () => {
        handleModalClose()
    }

    const handleRadioChange = (bankItemId: number, bankItemData: any) => {
        setSelectedBankItemId(bankItemId);
        setSelectedBankItemData(bankItemData);
    }

    const {
        data: bankLineItemsData,
        refetch: refetchBankLineItems,
        isFetching: isLoading,
        isSuccess,
    } = useGetAllBankLineItemsOfCurrentUserQuery(
        {
            pageNumber: pageNumber,
            pageSize: pageSize,
            sortBy: sortBy,
            sortOrder: sortOrder,

        },
        { skip: !show }
    )
    useEffect(() => {
        if (show) {
            setPageNumber(1); // Reset to first page when modal opens
            refetchBankLineItems()
        }
    }, [show, refetchBankLineItems])

    const handleModalClose = useCallback(() => {
        setSelectedBankItemId(null); // Reset radio selection
        setSelectedBankItemData(null); // Reset bank item data
        handleClose();
    }, [handleClose]);
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        // Check if a radio button is selected
        if (selectedBankItemId === null) {
            return; // Don't proceed if no radio button selected
        }
        setShowConfirmation(true) // confirmation modal open
    }

    // Pagination handlers
    const handlePageClick = (e: any) => {
        setPageNumber(e.selected + 1);
    };

    const handlePageSizeChange = (e: any) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        setPageNumber(1); // Reset page number to 1
    };


    return (
        <>
            <Modal
                id='kt_modal_create_app'
                tabIndex={-1}
                aria-hidden='true'
                dialogClassName='modal-dialog  modal-dialog-centered'
                show={show}
                onHide={handleModalClose}
                // onEntered={loadStepper}
                backdrop="static"
                fullscreen
            >
                <div className='modal-header'>
                    <h2>Merge With Bank LineItems
                    </h2>
                    <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleModalClose}>
                        <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                    </div>
                </div>

                <div className='modal-body px-lg-10'>
                    <Alert variant="primary" className='w-100 py-2'>
                        <p className='mb-0 fs-6 pt-1'>
                            You are about to merge the selected <strong>Expense Line Item</strong> with the chosen <strong>Bank Line Item</strong>.
                            Please review the details carefully before proceeding. </p>
                    </Alert>
                    <div
                        className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
                        id='kt_modal_create_app_stepper'
                    >
                        <form
                            className='form w-100'
                            onSubmit={handleSubmit}
                            id="bankLineItemForm"
                        >
                            <div className='modal-body px-lg-10'>
                                <div className="row">
                                    <div className='table-responsive table-height mt-5'>
                                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>{'Expense Report ID'}</th>
                                                    <th>{labelKey.lineItemDate}</th>
                                                    <th>{labelKey.category}</th>
                                                    <th>{labelKey.amount}</th>
                                                    <th>{labelKey.vendor}</th>
                                                    <th>{labelKey.paymentMethod}</th>
                                                    <th>{labelKey.description}</th>
                                                    <th>{labelKey.source}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bankLineItemsData?.result?.data && bankLineItemsData.result.data.length > 0 ? (
                                                    bankLineItemsData.result.data.map((item: any, index: number) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td className="ps-4">
                                                                    <div className="form-check form-check-sm form-check-custom form-check-solid me-3">
                                                                        <input
                                                                            type="radio"
                                                                            name="bankLineItem"
                                                                            className="form-check-input"
                                                                            value={item.expenseItemId}
                                                                            checked={selectedBankItemId === item.expenseItemId}
                                                                            onChange={() => handleRadioChange(item.expenseItemId, item)}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td>{item?.trackingId}</td>

                                                                <td className=''><DateComp formattedDate={item?.itemDate} /></td>
                                                                <td>{item?.expenseCategory?.title}</td>
                                                                <td className={`pe-4 ${item?.debitOrCreditIndicator === constraintConfig.debitOrCreditIndicator.creditIndicator ? 'text-danger' : null}`}>
                                                                    <CurrencyComp amount={item?.amount} />
                                                                </td>
                                                                <td>{item?.vendor?.name}</td>
                                                                <td>{item?.paymentMethod?.title}</td>


                                                                <td className='text-wrap'>
                                                                    {/* {data?.itemDetail?.length > 60 ? `${data?.itemDetail.substring(0, 40)}...` : data?.itemDetail} */}
                                                                    {item?.itemDetail && <ReactReadMoreReadLess
                                                                        charLimit={30}
                                                                        readMoreText={"Read more"}
                                                                        readLessText={"Read less"}
                                                                        readMoreClassName="readMore"
                                                                        readLessClassName="readLess"
                                                                    >
                                                                        {item?.itemDetail}
                                                                    </ReactReadMoreReadLess>}
                                                                </td>



                                                                <td>
                                                                    {item?.recordSourceId === constraintConfig.recordSourceId.WebApp ?
                                                                        <KTSVG path="/media/icons/figmaIcons/Web.svg" className='svg-icon-1 ms-4'
                                                                            data-tooltip-id="web-source" data-tooltip-content='Website' />
                                                                        :
                                                                        item?.recordSourceId === constraintConfig.recordSourceId.Mobile ?
                                                                            <KTSVG path="/media/icons/figmaIcons/Mobile.svg" className='svg-icon-1 ms-4'
                                                                                data-tooltip-id="mobile-source" data-tooltip-content='Mobile' /> :
                                                                            item?.recordSourceId === constraintConfig.recordSourceId.BankFeed ?
                                                                                <KTSVG path="/media/icons/figmaIcons/Bank.svg" className='svg-icon-1 ms-4'
                                                                                    data-tooltip-id="bank-source" data-tooltip-content='Bank' />
                                                                                : item?.recordSourceId === constraintConfig.recordSourceId.GorillaExpense ?
                                                                                    <KTSVG path="/media/icons/figmaIcons/Gorilla.svg" className='svg-icon-1 ms-4'
                                                                                        data-tooltip-id="gorilla-source" data-tooltip-content='Gorilla Expense' /> : null}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={5} className="text-center text-muted py-3">
                                                            No records found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className='px-lg-10 pb-4'>
                    {bankLineItemsData?.result?.data && bankLineItemsData.result.data.length > 0 && (
                        <div className="mt-4">
                            <Pagination
                                totalResult={bankLineItemsData?.result?.totalRecords === 0 ? 0 : ((bankLineItemsData?.result?.pageNumber - 1) * bankLineItemsData?.result?.pageSize) + 1}
                                toResult={bankLineItemsData?.result?.totalRecords === 0 ? 0 : Math.min(bankLineItemsData?.result?.pageNumber * bankLineItemsData?.result?.pageSize, bankLineItemsData?.result?.totalRecords)}
                                ofResult={bankLineItemsData?.result?.totalRecords}
                                onChange={handlePageSizeChange}
                                pageSize={pageSize}
                                onPageChange={handlePageClick}
                                pageCount={bankLineItemsData?.result?.totalPages || 0}
                                currentPage={pageNumber}
                            />
                        </div>
                    )}
                </div>
                <div className='modal-footer justify-content-end'>
                    <span className='btn btn-light' onClick={handleClose}>{labelKey.cancel}</span>
                    <button
                        type='submit'
                        className='btn btn-primary mb-5 mt-5'
                        disabled={isLoading || selectedBankItemId === null}
                        form="bankLineItemForm"
                    >
                        {!isLoading && <span className='indicator-label'>Compare & Merge</span>}
                        {isLoading && (
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                {labelKey.pleaseWait}...{' '}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )}
                    </button>
                </div>
            </Modal>
            <MergeLineItemConfirmationModal
                show={showConfirmation}
                handleClose={() => setShowConfirmation(false)}
                onConfirm={handleConfirmMerge}
                selectedDraftData={selectedDraftData}
                selectedBankItemData={selectedBankItemData}
                refetch={refetch}
                onMainModalClose={handleModalClose}
                onSuccess={onSuccess}
            />
        </>
    )
}

export default MergeExpenseModal